module.exports = __webpack_public_path__ + "FixelDisplay-Bold-164db87bdc87f05f791bf8241ce3dc16.woff2";